import { useAuth } from "@/contexts/AuthContext";
import { useProfile } from "@/contexts/ProfileContext";
import { ProfileForm } from "@/components/profile/ProfileForm";
import { TabbedProfile } from "@/components/profile/TabbedProfile";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const Profile = () => {
  const { user } = useAuth();
  const { profile } = useProfile();

  if (!profile) {
    return <div className="flex justify-center items-center min-h-screen bg-background text-foreground">
      Profile not found
    </div>;
  }

  const isCandidate = profile.role === 'candidate';

  return (
    <div className="min-h-screen bg-background">
      <div className="container max-w-7xl mx-auto py-6 px-6 md:px-12 lg:px-24 space-y-6 md:space-y-8">
        <div className="bg-card rounded-lg shadow-sm border border-border max-w-4xl mx-auto">
          {!isCandidate ? (
            <TabbedProfile 
              initialData={profile} 
            />
          ) : (
            <ProfileForm 
              initialData={profile} 
              showCompanyTab={false} 
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Profile;